import { render, staticRenderFns } from "./unitNameDialog.vue?vue&type=template&id=4b4dd040&scoped=true"
import script from "./unitNameDialog.vue?vue&type=script&lang=js"
export * from "./unitNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dd040",
  null
  
)

export default component.exports